import { render, staticRenderFns } from "./ProjectDatasheet.vue?vue&type=template&id=42c379ca&scoped=true&"
import script from "./ProjectDatasheet.vue?vue&type=script&lang=js&"
export * from "./ProjectDatasheet.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDatasheet.vue?vue&type=style&index=0&id=42c379ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c379ca",
  null
  
)

export default component.exports